import {$axios} from "dot-framework"
import $store from "@/store"
import axios from "axios"

const handleLoading = (showLoading, flag) => {
    if (showLoading) {
        $store.commit('common/setLoading', flag)
    }
}

const self = {
    $get: async (url, params = null, showLoading = false) => {
        handleLoading(showLoading, true)
        
        return $axios
            .get(url, params)
            .then((response) => {
                return response
            })
            .catch((error) => {
                console.error(`[Error] ($get) ${url}:`, error)
                return null
            })
            .finally(() => {
                handleLoading(showLoading, false)
            })
    },
    $post: async (url, params, config, showLoading = false) => {
        handleLoading(showLoading, true)
        
        return $axios.post(url, params, config)
            .then((response) => {
                return response
            })
            .catch((error) => {
                console.error(`[Error] ($post) ${url}:`, error)
                return null
            })
            .finally(() => {
                handleLoading(showLoading, false)
            })
    },
    $post_noloading: async (url, params, config) => {
        return $axios.post(url, params, config)
            .then((response) => {
                return response
            })
            .catch((error) => {
                console.error(`[Error] ($post) ${url}:`, error)
                return null
            })
            .finally(() => {
            })
    },
    $put: async (url, params, config, showLoading = false) => {
        handleLoading(showLoading, true)
        
        return $axios.put(url, params, config)
            .then((response) => {
                return response
            })
            .catch((error) => {
                console.error(`[Error] ($put) ${url}:`, error)
                return null
            })
            .finally(() => {
                handleLoading(showLoading, false)
            })
    },
    $patch: async (url, params, config, showLoading = false) => {
        handleLoading(showLoading, true)
        
        return $axios.patch(url, params, config)
            .then((response) => {
                return response
            })
            .catch((error) => {
                console.error(`[Error] ($patch) ${url}:`, error)
                return null
            })
            .finally(() => {
                handleLoading(showLoading, false)
            })
    },
    $delete: async function (url, params, config, showLoading = false) {
        handleLoading(showLoading, true)

        // axios 의 delete 는 (url, config) 두 개만 받는다. params 를 두 번째 자리에 그대로
        // 넘기면 그것이 config 로 해석되어 요청 본문이 비어 나간다. 본문을 보내려면
        // config.data 에 실어야 한다. 세 번째 자리에 boolean 을 넘겨 온 호출부가 있어
        // 객체가 아닌 config 는 없는 것으로 본다.
        const baseConfig = config && typeof config === "object" ? config : undefined
        const requestConfig = params == null ? baseConfig : {...(baseConfig || {}), data: params}

        return $axios.delete(url, requestConfig)
            .then((response) => {
                return response && (response.status === 200 || response.status === 201)
            })
            .catch((error) => {
                console.error(`[Error] ($delete) ${url}:`, error)
                return false
            })
            .finally(() => {
                handleLoading(showLoading, false)
            })
    },
    post: async function(url, params, config, showLoading = true) {
        handleLoading(showLoading, true)

        return axios
            .post(url, params, config)
            .then((response) => {
                if (response.status === 200 || response.status === 201) {
                    return response.data
                } else {
                    return response.data.errors
                }
            })
            .catch((error) => {
                console.error(`[Error] (post) ${url}:`, error)
                return null
            })
            .finally(() => {
                handleLoading(showLoading, false)
            })
    },
}

export default self